module.exports = __webpack_public_path__ + "static/media/logo-gra@2x.23da1cec.png";